import { QueryClient } from "@tanstack/react-query";
import { ExpiredError } from "./api/client";

const throwOnError = (error: Error) => error instanceof ExpiredError;

export const client = new QueryClient({
  defaultOptions: {
    queries: { throwOnError, retry: 1 },
    mutations: { throwOnError, retry: 1 },
  },
});
